angular.module("app")

    .service('LanguagesService', ["$q", "Restangular", function ($q, Restangular) {
        var service = {
            languages: function (name, pw) {
                var deferred = $q.defer();
                var promise = deferred.promise;
                Restangular.all('Languages').getList({ use_for_translation: true }).then(function (languages) {
                    deferred.resolve(languages);
                },
                    function (error) {
                        deferred.reject(error);
                    });
                return promise;
            }
        };
        return service;
    }]);
    /*
.provider('LanguagesService', function () {
    var provider = {};
    provider.$get = function ($http, $q, Restangular) {
        var service = {
            languages: function (name, pw) {
                var deferred = $q.defer();
                var promise = deferred.promise;
                Restangular.all('Languages').getList().then(function (languages) {
                    deferred.resolve(languages);
                },
                function (error) {
                    deferred.reject(error);
                });
                return promise;
            }
        };
        return service;
    };
    return provider;
})*/
